<div class="subBlockContainer" id="cataloguesubscription">
    <div class="subBlockContent subBlockContent-width">
      <loading-screen *ngIf="!loadContent" [isScrolled]="true" backDropWidth="300"
        (currentLoadingStatus)="onLoading($event)"></loading-screen>
      <child-header [title]="title"  (closeEvent)="close()" ></child-header>
      <div class="inner-subBlock-wrapper" *ngIf="loadContent">
        <mat-checkbox [(ngModel)]="checkedPromotions">
          Promotions
        </mat-checkbox>
        <div class="catalogue-title-description">
          Receive a copy of our weekly catalogues and electronic direct marketing materials.
        </div>
        <mat-checkbox [(ngModel)]="checkedDatafeedsCsv">
          Datafeeds - CSV
        </mat-checkbox>
        <div class="catalogue-title-description">
          Receive a comma delimited CSV file daily that contains all active products
          their descriptions, SOH and price
        </div>
        <div class="submitButton">
          <div class="row">
            <div class="col-12 align-center">
              <button class="button button-red button-large button-width" (click)="update()">Update subscriptions</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>